import { AdvertisementTypeEnum } from "@app/types/enums";
import garageLogo from "@assets/verticals/garage-logo-black.svg";
import WinIfraLogo from "@assets/verticals/garage-win-infra.png";
import Advertisement from "@components/Advertisement/Advertisement";
import PrestitialAd from "@components/Advertisement/PrestitialAd";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { sectionNavigationItems } from "@util/constant";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function GarageBanner(): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const slot = sectionNavigationItems["international/startups"]
    ? GoogleAdsSlotFactory.lb1(
        sectionNavigationItems["international/startups"].link
          .split("/")
          .filter((a) => a !== "")
          .join("/")
      )
    : null;
  return (
    <>
      {sectionNavigationItems["startups-tech/startups"] ? (
        <SectionMasthead
          link={sectionNavigationItems["startups-tech/startups"].link}
          masthead={{
            alt: "Garage logo",
            src: garageLogo,
            width: 111,
            height: 40,
          }}
        />
      ) : null}

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex flex-row items-center gap-x-4">
          <img src={WinIfraLogo} alt="UOB logo" width="62" height="46" />

          <span className="font-poppins text-base font-light">
            BEST DIGITAL NEWS START-UP, WAN-IFRA 2019 GOLD AWARD
          </span>
        </div>
      </Banner>

      {slot ? (
        <>
          <Advertisement
            rootClassName="pb-6"
            adUnitProps={{ type: AdvertisementTypeEnum.LB1, slot: slot }}
          />

          {OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER ? (
            <PrestitialAd slot={slot} />
          ) : null}
        </>
      ) : null}
    </>
  );
}
